import { Flag } from '../parsing-utils'
import MechanismFieldParser from './mechanism_field_parser'
import Choice from '../../models/mechanism/choice'

export default class ChoiceParser extends MechanismFieldParser {

  parseDefinition (name, definition) {
    const choice = ASSIGNMENT_CHOICE_FLAG.execute(definition, {
      onTrue: (assignmentChoiceText, match) => this._parseAssignmentChoice(name, assignmentChoiceText),
      onFalse: () => FIELD_CHOICE_FLAG.execute(definition, {
        onTrue: (fieldChoiceText, match) => this._parseFieldChoice(name, fieldChoiceText),
        onFalse: (typeChoiceText) => this._parseTypeChoice(name, typeChoiceText)
      })
    })

    return this.add(choice)
  }

  _parseTypeChoice (name, choiceText) {
    const [type, reccomendations] = RECCOMENDATIONS_FLAG.extract(choiceText)
    return new Choice.TypeChoice(name, type, reccomendations)
  }

  _parseFieldChoice (name, choiceText) {
    return new Choice.FieldChoice(name, choiceText)
  }

  _parseAssignmentChoice (name, choiceText) {
    const [targetText, sourceText] = TARGET_FLAG.extract(choiceText)
    const [distinct, source] = DISTINCT_FLAG.extract(sourceText)
    return new Choice.AssignmentChoice(name, source, targetText.split(',').map(x => x.trim()), distinct)
  }
}

const RECCOMENDATIONS_FLAG = new Flag.Parameter('with recommendations from')
const FIELD_CHOICE_FLAG = new Flag.Prefix('from')
const ASSIGNMENT_CHOICE_FLAG = new Flag.Prefix('assign')
const DISTINCT_FLAG = new Flag.Suffix('each')
const TARGET_FLAG = new Flag.Parameter('to')
